import * as yup from 'yup';
//const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
//const phoneRegExp = /^\+?[1-9]\d{1,14}$/;
const validateSignUpForm = yup.object({
  firstName: yup
    .string()
    .min(2, 'Must be longer than 2 characters')
    .max(25, 'First name is too long. Should be less than 25 characters')
    .required('First name is a required field'),
  lastName: yup
    .string()
    .min(2, 'Must be longer than 2 characters')
    .max(25, 'First name is too long. Should be less than 25 characters')
    .required('Last name is a required field'),
  email: yup.string().required('Email is a required field').email('Email must be a valid email'),
  password: yup
    .string()
    .required('Password is a required field')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{12,}$/,
      'Must contain 12 characters or more, one uppercase, one lowercase, one number and one special case character'
    ),
  phone: yup.string().required('Phone number is a required field'),
  checkTerm: yup.boolean().oneOf([true], 'The terms and conditions must be accepted')
});

export default validateSignUpForm;
